import React, { useContext } from 'react'

import { NormalPlan } from 'modules/billing/lib/prices'
import { PeriodUnit } from 'modules/onboarding/lib/pricing/types'

type PriceVariants = {
  totalPrice: number
  perSeatPrice: number
  fixedFeePrice: number
}

export type PricingBundleData = {
  currency: string
  period: PeriodUnit
  employeeSeats: number
  current: CurrentData
}

export type PricePeriods = {
  yearly: PriceVariants
  monthly: PriceVariants
}

export type CurrentData = PricePeriods & {
  selectedBundle: string
}

type PricingBundleContextType = {
  planType: string
  addons: NormalPlan[]
  currentData: CurrentData | undefined
  isYearly: boolean
}

type PricingBundleContextProviderProps = {
  selectedBundle: string
  isYearly: boolean
  extraAddons: NormalPlan[]
  children: React.ReactNode | React.ReactNode[]
  employeeSeats: number
  currentPlanPricing: PricePeriods
  planType: string
  currency: string
}

const PricingBundleContext = React.createContext<PricingBundleContextType>({
  planType: '',
  addons: [],
  currentData: undefined,
  isYearly: false,
})
export const usePricingBundleContext = () => useContext(PricingBundleContext)
